const DEFAULT_PREFS = {
  assistant_enabled: true,
  summary_enabled: true,
  briefing_enabled: true,
  transcription_enabled: true,
  prescription_validation_enabled: true,
  prescription_chat_enabled: true,
  floating_mic_shortcut: true,
};

function storageKey(professionalId) {
  return `ubbi_ai_assistant_prefs_${professionalId}`;
}

export const AI_ASSISTANT_PREFS_CHANGED = 'ubbi:ai-assistant-prefs-changed';

export function loadAiAssistantPrefs(professionalId) {
  try {
    const raw = localStorage.getItem(storageKey(professionalId));
    if (!raw) {
      return { ...DEFAULT_PREFS };
    }

    return { ...DEFAULT_PREFS, ...JSON.parse(raw) };
  } catch {
    return { ...DEFAULT_PREFS };
  }
}

export function saveAiAssistantPrefs(professionalId, prefs) {
  localStorage.setItem(storageKey(professionalId), JSON.stringify(prefs));
  window.dispatchEvent(new CustomEvent(AI_ASSISTANT_PREFS_CHANGED, {
    detail: { professionalId: String(professionalId ?? '') },
  }));
}

export function getDefaultAiAssistantPrefs() {
  return { ...DEFAULT_PREFS };
}

export function resolveEffectiveAiFeatures(recordTypes, profPrefs) {
  const activeTypes = (recordTypes || []).filter((rt) => rt.active !== false);

  const anyType = (field) => activeTypes.some((rt) => rt[field] !== false);
  const prof = (field) => profPrefs?.[field] !== false;

  const typeAssistant = anyType('ai_assistant_enabled');
  const typeSummary = anyType('ai_summary_enabled');
  const typeTranscription = anyType('ai_transcription_enabled');
  const typeValidation = anyType('ai_prescription_validation_enabled');
  const typeChat = anyType('ai_prescription_chat_enabled');
  const hasPrescription = activeTypes.some((rt) => rt.allow_prescription);

  const assistantEnabled = typeAssistant && prof('assistant_enabled');

  const hasActiveFeatures = assistantEnabled && (
    (typeSummary && prof('summary_enabled')) ||
    (typeSummary && prof('briefing_enabled')) ||
    (typeTranscription && prof('transcription_enabled')) ||
    (hasPrescription && typeValidation && prof('prescription_validation_enabled')) ||
    (hasPrescription && typeChat && prof('prescription_chat_enabled'))
  );

  return {
    triggerVisible: typeAssistant,
    visible: hasActiveFeatures,
    hasActiveFeatures,
    allPrefsDisabled: typeAssistant && !hasActiveFeatures,
    summary: assistantEnabled && typeSummary && prof('summary_enabled'),
    briefing: assistantEnabled && typeSummary && prof('briefing_enabled'),
    patientChat: assistantEnabled && typeSummary && (prof('summary_enabled') || prof('briefing_enabled')),
    transcription: assistantEnabled && typeTranscription && prof('transcription_enabled'),
    prescriptionValidation: assistantEnabled && hasPrescription && typeValidation && prof('prescription_validation_enabled'),
    prescriptionChat: assistantEnabled && hasPrescription && typeChat && prof('prescription_chat_enabled'),
    floatingMicShortcut: assistantEnabled && typeTranscription && prof('transcription_enabled') && prof('floating_mic_shortcut'),
    hasPrescription,
    typeSummary,
    typeTranscription,
    typeValidation,
    typeChat,
  };
}
